module.exports = __webpack_public_path__ + "assets/img/gpt-bg.d3df1471.png";